import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['display', 'editor', 'input', 'submit'];

  edit() {
    this.displayTarget.classList.add('hidden');
    this.editorTarget.classList.remove('hidden');
    this.inputTarget.disabled = false;
    this.inputTarget.focus();

    const label = this.submitTarget.querySelector('span');
    if (label) label.textContent = 'Save & Approve';
    this.submitTarget.dataset.turboSubmitsWith = 'Save & Approve';
  }
}
